// ── refTag ────────────────────────────────────────────────────────────────────
// Every outward share URL was going out untagged, so a signup driven by someone
// sharing a show/review/card was indistinguishable from organic direct traffic in
// admin_attribution() (props->>'ref', stamped client-side on first touch and
// carried through to app_events). Not a "nice to have" — it's the only way to
// ever know whether the share-card loop actually produces accounts (Jason,
// 2026-08-06 growth conversation: the loop was invisible in the data because it
// was never instrumented, not because it wasn't working).
//
// `source` should be a short, stable slug identifying WHAT was shared, not who
// shared it, e.g. 'show', 'review', 'collection', 'aftershow', 'invite',
// 'wrapped-card'. Every value in the wild becomes its own row in
// admin_attribution(), so keep the vocabulary small and reused rather than
// inventing a new slug per call site.
export function withShareRef(url, source) {
  if (!url || !source) return url
  try {
    const u = new URL(url, typeof window !== 'undefined' ? window.location.origin : undefined)
    if (!u.searchParams.has('ref')) u.searchParams.set('ref', `share-${source}`)
    return u.toString()
  } catch {
    // Not a parseable absolute/relative URL (shouldn't happen for our own share
    // links) — fail open rather than break the share.
    return url
  }
}
